import { GetLocalStorageValue } from '../../../../_config/utils/get-local-storage-value.util';

const user = GetLocalStorageValue('userInfo');

export const checkRol = (pharmacy) => {
	if (user?.pharmacy) return '/v2/reserve/list?page=1&status=100';
	return `/v2/admin-reserve/list?page=1&status=100`;
};
